module.exports = __webpack_public_path__ + "media/images/admin/icons/linkedin-9e52cf326e0bbf3cd9a3378906c0d35c.svg";